import React, { useState } from 'react';

const TrabajaConNosotros = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    experiencia: '',
    cv: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: files ? files[0] : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el formulario
    console.log(formData);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#8B0000] mb-4">Trabaja con Nosotros</h1>
          <p className="text-lg text-gray-600">Únete a nuestro equipo y forma parte de una empresa en constante crecimiento</p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1">
                Nombre Completo *
              </label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="experiencia" className="block text-sm font-medium text-gray-700 mb-1">
                Años de Experiencia *
              </label>
              <input
                type="number"
                id="experiencia"
                name="experiencia"
                required
                min="0"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="cv" className="block text-sm font-medium text-gray-700 mb-1">
                Subir CV (PDF) *
              </label>
              <input
                type="file"
                id="cv"
                name="cv"
                accept=".pdf"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500"
                onChange={handleChange}
              />
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="px-8 py-3 bg-[#8B0000] text-white font-medium rounded-md hover:bg-[#A52A2A] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors duration-300"
              >
                Enviar Solicitud
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TrabajaConNosotros; 